import { render } from "./PromotionList.vue?vue&type=template&id=7fe2bfe0&scoped=true&ts=true"
import script from "./PromotionList.vue?vue&type=script&lang=ts"
export * from "./PromotionList.vue?vue&type=script&lang=ts"

import "./PromotionList.vue?vue&type=style&index=0&id=7fe2bfe0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe2bfe0"]])

export default __exports__